import React, {Component} from 'react';
import {Link} from 'react-router-dom'

export default class TableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            company: props.company,
        }
    }

    getModuleProcessedItem(module) {
        for (let i in this.state.company.modules) {
            if (this.state.company.modules[i].code === module.code) {
                return this.state.company.modules[i].processedItemCount + ' db';
            }
        }
        return '-';
    }

    render() {
        return (
            <tr>
                <td>{this.state.company.name}</td>
                <td className='text-center'>{this.state.company.lastProcessedDate || ''}</td>
                <td className='text-center' key={'company-row-cell-' + Math.random(9999, 99999)}>
                    {this.state.company.modules[1].processedItemCount} db
                </td>
                <td className='text-center' key={'company-row-cell-' + Math.random(9999, 99999)}>
                    {this.state.company.modules[0].processedItemCount} db
                </td>
                <td className='float-md-right'>
                    <Link
                        className="btn btn-sm table-green-btn"
                        to={`start/customer/${this.state.company.id}`} style={{marginLeft: '1px'}}>
                        Vevő
                    </Link>
                    <Link
                        className="btn btn-sm table-green-btn"
                        to={`start/supplier/${this.state.company.id}`} style={{marginLeft: '1px'}}>
                        Szállító
                    </Link>
                </td>
            </tr>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/company/TableRow.js